import React from 'react';

import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { CreatorCollectionCard } from '@eventbrite/creator-collection-card';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { useLocationContext } from '../../context';
import { CREATOR_NAME, EVENTBRITE_LOGO } from './constants/constants';
import { CollectionShape } from './types/CollectionShape';
import './UniqueExperiences.scss';

export interface UniqueExperiencesProps {
    editorialCollections: CollectionShape[];
}

const UniqueExperiencesHeader = () => {
    return (
        <div className="ttd_unique_experiences_carousel-header--title">
            <p className="eds-text-hs">
                {gettext('Dive into unique experiences')}
            </p>
        </div>
    );
};

interface SubtitleProps {
    text: string | GenericLazyString;
}

export const UniqueExperiencesSubtitle: React.FunctionComponent<
    SubtitleProps
> = (props) => {
    const { text } = props;
    return (
        <div className="ttd_unique_experiences_carousel--subtitle">
            <p>{text}</p>
        </div>
    );
};

export const UniqueExperiences: React.FunctionComponent<
    UniqueExperiencesProps
> = (props) => {
    const { shortPlaceName } = useLocationContext();
    const subtitleText = gettext(
        'Discover more of what %(shortPlaceName)s has to offer with event collections from Eventbrite and local organizers',
        { shortPlaceName: shortPlaceName },
    );

    return (
        <>
            {props.editorialCollections.length > 0 ? (
                <ThingsToDoSection>
                    <div className="ttd_unique_experiences_carousel-container">
                        <SimpleCarousel
                            slidesVisible={{ desktop: 3, tablet: 3 }}
                            headerTitle={<UniqueExperiencesHeader />}
                            subtitle={
                                <UniqueExperiencesSubtitle
                                    text={subtitleText}
                                />
                            }
                            lazilyRenderOffScreenElements={true}
                        >
                            {props.editorialCollections.map(
                                ({
                                    id,
                                    image_large = {},
                                    image_url,
                                    name,
                                    summary,
                                    relative_url,
                                    event_count = 0,
                                    display_creator_name,
                                    creator_image_id_override_url,
                                }) => {
                                    const slug = relative_url
                                        ? `${relative_url}`
                                        : `/c/${id}/`;

                                    return (
                                        <div
                                            style={{ width: '95%' }}
                                            key={id}
                                            data-testid="ttd_unique_experiences_carousel-slide"
                                        >
                                            <CreatorCollectionCard
                                                slug={slug}
                                                name={name}
                                                summary={summary}
                                                id={id}
                                                hideBoxShadow={true}
                                                imageUrl={
                                                    image_url ?? image_large.url
                                                }
                                                numUpcomingEvents={event_count}
                                                shouldOpenNewTab={true}
                                                organizer={{
                                                    name:
                                                        display_creator_name ||
                                                        CREATOR_NAME.EVENTBRITE,
                                                    imageUrl:
                                                        creator_image_id_override_url ||
                                                        EVENTBRITE_LOGO,
                                                }}
                                                __containerClassName={
                                                    'ttd_unique_experiences_carousel-card'
                                                }
                                            />
                                        </div>
                                    );
                                },
                            )}
                        </SimpleCarousel>
                    </div>
                </ThingsToDoSection>
            ) : (
                <></>
            )}
        </>
    );
};
